<template>
  <div>
    <q-dialog v-model="salvar">
      <q-card style="width: 800px; max-width: 80vw">
        <div
          style="width: 100%; height: 100%"
          class="column justify-between col-12"
        >
          <div class="q-ma-md text-h6 text-brand-5 text-weight-bold">
            Salvar Relatório
          </div>
          <div class="q-mt-md q-mx-md text-weight-bold text-brand-5">
            <div>Nome</div>
            <q-input
              style="width: 100%"
              class="row justify-center q-mb-lg"
              dense
              v-model="nome"
              outlined
              label="Digite o nome"
              type="text"
            />

            <div class="row col-12 q-gutter-sm">
              <div
                v-if="
                  $route.params.id != undefined &&
                  $route.params.id != '' &&
                  $route.params.id != 'carregado'
                "
                class="col"
              >
                <q-btn
                  style="width: 100%"
                  no-caps
                  class="q-mt-sm"
                  icon="edit"
                  color="primary"
                  label="Editar Relatório"
                  :disable="carregar"
                  @click="$emit('emitir', nome, 'editar')"
                />
              </div>
              <div class="col">
                <q-btn
                  style="width: 100%"
                  no-caps
                  class="q-mt-sm"
                  icon="save"
                  color="positive"
                  :label="
                    $route.params.id != undefined &&
                    $route.params.id != '' &&
                    $route.params.id != 'carregado'
                      ? 'Salvar Novo Relatório'
                      : 'Salvar Relatório'
                  "
                  :disable="carregar"
                  @click="$emit('emitir', nome, 'salvar')"
                />
              </div>
              <div class="col">
                <q-btn
                  no-caps
                  style="width: 100%"
                  class="q-mt-sm"
                  color="brand-1"
                  icon="file_download"
                  label="Salvar Arquivo Local"
                  :disable="carregar"
                  @click="$emit('salvarLocal', nome || relatorioSalvo)"
                />
              </div>
            </div>
          </div>
        </div>
      </q-card>
    </q-dialog>
  </div>
</template>

<script>
import { ref, watch } from "vue";
export default {
  props: ["abrir", "loading", "relatorioSalvo"],
  setup(props) {
    const salvar = ref(false);
    const nome = ref();
    const carregar = ref(false);

    watch(
      () => props.abrir,
      () => {
        if (salvar.value == false) {
          salvar.value = true;
        } else {
          salvar.value = false;
        }
      }
    );

    watch(
      () => props.loading,
      () => {
        carregar.value = props.loading;
        if (props.loading == false) {
          salvar.value = false;
          nome.value = "";
        }
      }
    );

    return {
      salvar,
      nome,
      carregar,
    };
  },
};
</script>

<style></style>
